export const ORTHO_TRANSFER_DEMO_ID = "tutorial-ortho-transfer";
export const ORTHO_TRANSFER_DEMO_ROUTE = `/patients/${ORTHO_TRANSFER_DEMO_ID}?tutorial=ortho-transfer-case&demo=1&tab=ortho`;
export const orthoTransferDemoRoute = (stage = "open") => `${ORTHO_TRANSFER_DEMO_ROUTE}&stage=${stage}`;

const DEMO_DATE_STARTED = "2025-01-15";
const DEMO_LAST_VISIT = "2026-04-20";

export const ORTHO_TRANSFER_DEMO = {
  patient: {
    id: ORTHO_TRANSFER_DEMO_ID,
    full_name: "Althea Ramos",
    first_name: "Althea",
    last_name: "Ramos",
    status: "Active",
    phone: "09175551234",
    email: "althea.ramos@example.com",
    address: "Pasig City, Metro Manila",
    patient_number: "ORTHO-DEMO-001",
    preferred_contact_method: "sms",
    preferred_doctor_name: "Dr. Mara Santos",
    has_medical_history: true,
    recall_status: "Priority",
    recall_opt_in: true,
    senior_pwd_status: "none",
    last_visit_date: DEMO_LAST_VISIT,
    current_phase: 1,
    total_phases: 1,
    pending_treatment_centavos: 5500000,
    balance_centavos: 5500000,
  },
  ltvSummary: {
    currency: "PHP",
    lifetime_collected_centavos: 0,
    confirmed_payment_count: 0,
    last_payment_date: null,
  },
  txPlanAlerts: [],
  orthoPanel: {
    doctors: [
      {
        id: "tutorial-ortho-doctor-1",
        profile_id: "tutorial-profile-1",
        full_name: "Dr. Mara Santos",
        display_name: "Dr. Mara Santos",
        prc_license: "PRC-0000000",
      },
      {
        id: "tutorial-ortho-doctor-2",
        profile_id: "tutorial-profile-2",
        full_name: "Dr. Levi Jordan",
        display_name: "Dr. Levi Jordan",
        prc_license: "PRC-0000001",
      },
    ],
    systems: [
      {
        id: "tutorial-fixed-metal",
        display_name: "Fixed Metal Braces",
        category: "fixed_metal",
        default_price_centavos: 8500000,
      },
      {
        id: "tutorial-aligner",
        display_name: "Clear Aligner",
        category: "aligner",
        default_price_centavos: 12000000,
      },
    ],
    wireOptions: [],
    settings: {
      billing_setup_roles: ["clinic_admin", "receptionist"],
      reconciliation_default_disposition: "collect_remaining",
    },
    rows: [],
    importedRows: [
      {
        case: {
          id: "tutorial-transfer-case-1",
          case_type: "fixed",
          system: "Fixed Metal Braces",
          system_name: "Fixed Metal Braces",
          status: "active",
          primary_doctor_id: "tutorial-ortho-doctor-1",
          estimated_total_visits: 18,
          migration_source: "migrated",
          migration_started_at: DEMO_DATE_STARTED,
          migration_data_quality: "partial",
          chief_complaint: "Transfer from previous clinic. Patient reports seven adjustments done and wants to continue locally.",
          starting_photos: [],
          ready_for_debonding: false,
        },
        billing: {
          id: "tutorial-transfer-billing-1",
          billing_model: "per_visit_divisor",
          billing_variant: "B",
          package_price_centavos: 8500000,
          down_payment_centavos: 0,
          down_payment_status: "waived",
          per_visit_charge_centavos: 500000,
          estimated_total_visits: 18,
          number_of_payments: 11,
        },
        balance: {
          total_collected_centavos: 0,
          contract_remaining_centavos: 5500000,
          balance_remaining_centavos: 5500000,
          writeoff_centavos: 0,
        },
        historical_payments: [
          {
            total_paid_prior_centavos: 3000000,
            note: "Prior clinic records show PHP 30,000 paid before transfer.",
          },
        ],
        visits: Array.from({ length: 7 }, (_, index) => ({
          ortho_visit: {
            id: `tutorial-historical-visit-${index + 1}`,
            visit_type: "adjustment",
            visit_number: index + 1,
            occurred_at: index === 6 ? `${DEMO_LAST_VISIT}T09:00:00.000Z` : null,
            next_visit_interval_weeks: 4,
          },
        })),
        monthly_schedule: null,
        milestones: [],
        retainer_setup: null,
      },
    ],
  },
};
